<template>
  <div class="about_container">
    <div class="about_wrapper">
      <div class="license_box">
        <js-title
          zh="资质证书"
          alignItems="flex-start"
          fontSizeZh="28px"
          height="100px"
        />
        <router-link tag="div" to="/about/license" class="more">
          更多&gt;&gt;&gt;
        </router-link>
        <div class="license_wrapper">
          <div class="license"></div>
          <div class="license"></div>
          <div class="license"></div>
        </div>
      </div>
      <div class="contact_box">
        <js-title
          zh="关于我们"
          alignItems="flex-start"
          fontSizeZh="28px"
          height="100px"
          colorZh="#FFF"
          colorLine="#FFF"
        />
        <router-link tag="div" to="/about/profile" class="more">
          更多&gt;&gt;&gt;
        </router-link>
        <div class="contact_wrapper">
          上海甲申速递有限公司成立于2015年，注册资金为人民币3000万元。公司具有快递业务经营许可证、国际货运代理企业备案表、航空运输销售代理国际、国内业务资质认可证书、报关单位注册登记证书等相关资质。我司在上海、天津、大连、青岛、烟台、威海、南京、宁波、武汉、广州、深圳有自己分公司，在美国、日本、澳大利亚、中国香港地区有自己的全资公司。我司是中国邮政速递物流股份有限公司的国际航空运能供应商，也取得了进出境快件营运人的资质，在全国多口岸提供快件及跨境电商（9610）进出口通关、航空运输服务……
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JsTitle from '@/packages/JsTitle'
export default {
  name: 'About',
  components: {
    JsTitle
  }
}
</script>

<style lang="scss" scoped>
.about_container {
  width: 100%;
  padding: 50px 0px 50px;
  background-color: #F2F2F2;
  .about_wrapper {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    box-sizing: border-box;
    padding: 0 20px;
    justify-content: space-around;
    flex-wrap: wrap;
    .license_box {
      flex: 2;
      margin-right: 5px;
      position: relative;
      .more {
        position: absolute;
        top: 0px;
        right: 30px;
        color: #00439a;
        font-size: 18px;
        line-height: 100px;
        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }
      .license_wrapper {
        display: flex;
        justify-content: space-between;
        .license {
          width: 230px;
          height: 330px;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center center;
          &:nth-of-type(1) {
            background-image: url('/img/certificate/备案表.jpg');
          }
          &:nth-of-type(2) {
            background-image: url('/img/certificate/一类货运.jpg');
          }
          &:nth-of-type(3) {
            background-image: url('/img/certificate/进出境快件运营人代理报关登记表.jpg');
          }
        }
      }
    }
    .contact_box {
      flex: 1;
      position: relative;
      padding: 0 15px;
      border-radius: 5px;
      background-color: #00439a;
      .more {
        position: absolute;
        top: 0px;
        right: 15px;
        color: #FFF;
        font-size: 18px;
        line-height: 100px;
        &:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }
      .contact_wrapper {
        max-height: 320px;
        overflow: auto;
        color: #FFF;
        line-height: 22px;
        text-indent: 2em;
        text-align: justify;
      }
    }
  }
}
</style>
